import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaEye, FaHeart, FaTimesCircle, FaArrowLeft, FaCheck, FaLightbulb, FaArrowRight, FaArrowCircleLeft, FaArrowCircleRight, FaChalkboardTeacher, FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../dashboard/navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import axios from 'axios';
import { getAuthToken } from '../../authToken';

const Etude_demarrer = () => {
    useAuth(); // Vérifier l'authentification
    const location = useLocation();

    const [qcms, setQcms] = useState([]);
    const [showInfo, setShowInfo] = useState(false);
    const [alert, setAlert] = useState({ message: '', type: '' });
    const [answers, setAnswers] = useState({});
    const user_id = localStorage.getItem('user_id');
    const { etude_id } = location.state || {};
    const navigate = useNavigate();
    const [etude, setEtude] = useState([]);
    const [currentQcmIndex, setCurrentQcmIndex] = useState(0);
    const [selectedAnswer, setSelectedAnswer] = useState(null);
    const [explanationVisible, setExplanationVisible] = useState(false);
    const [feedbackVisible, setFeedbackVisible] = useState(false);
    const [isAnswerCorrect, setIsAnswerCorrect] = useState(null);
    const [isLoading, setIsLoading] = useState(false); // Pour gérer le loader
    const [isButtonLoading, setIsButtonLoading] = useState(false);


    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Demarrer Etude";
        }
    }, [user_id]);

    const handleFinishEtude = async () => {
        // Logique de terminaison de etude
        setIsButtonLoading(true)
        try {
            const token = localStorage.getItem('access_token');

            const response = await fetch(`${process.env.REACT_APP_HOTE}/enregistrer-reponses-qcm-etude/${user_id}/${etude_id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    answers: answers
                }),
            });
            const response2 = await fetch(`${process.env.REACT_APP_HOTE}/pourcentage-etude/${user_id}/${etude_id}/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });
            if (!response2.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            if (response.ok) {
                const data = await response.json();
                localStorage.removeItem('answers');
                localStorage.removeItem('currentQcmIndex');
                navigate(`/Resultats-etude`, {
                    state: { etude_id: etude_id },
                });
            } else {
                const data = await response.json();
                console.error('Erreur lors de l\'enregistrement des réponses', data);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        } finally {
            setIsButtonLoading(false)
        }
    };

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    useEffect(() => {
        // Sauvegarde de l'index actuel à chaque changement
        if (qcms.length > 0) {
            localStorage.setItem('currentQcmIndex', currentQcmIndex);
        }
    }, [currentQcmIndex, qcms]);

    useEffect(() => {
        const fetchEtudesqcm = async () => {
            setIsLoading(true)
            try {
                const token = localStorage.getItem('access_token');

                const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-qcms-etude/${user_id}/${etude_id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });
                // const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-qcms-etude/${user_id}/${etude_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setQcms(data.qcms);
                } else {
                    console.error('Erreur lors de la récupération des Etudes');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsLoading(false)
            }
        };

        fetchEtudesqcm();
    }, [user_id, etude_id]);

    useEffect(() => {
        if (etude_id) { // Vérifiez que etude_id existe avant de lancer la requête
            const fetchEtudes = async () => {
                try {
                    const token = localStorage.getItem('access_token');

                    const response = await fetch(process.env.REACT_APP_HOTE + `/recuperer-etude/${user_id}/${etude_id}/`, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    // const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-etude/${user_id}/${etude_id}/`);
                    if (response.ok) {
                        const data = await response.json();
                        setEtude(data);
                    } else {
                        console.error('Erreur lors de la récupération des etudes');
                    }
                } catch (error) {
                    console.error('Erreur réseau:', error);
                }
            };
            fetchEtudes();
        }
    }, [user_id, etude_id]);

    // const handleAnswerChange = (qcmId, selectedValue) => {
    //     setSelectedAnswer({ qcmId, value: selectedValue });
    //     setExplanationVisible(false);
    //     setFeedbackVisible(false); // Réinitialiser la visibilité des feedbacks
    //     setIsAnswerCorrect(null); // Réinitialiser l'état de la réponse correcte

    //     setAnswers(prevAnswers => ({
    //         ...prevAnswers,
    //         [qcmId]: selectedValue
    //     }));
    // };



    useEffect(() => {
        const savedAnswers = localStorage.getItem('answers');
        if (savedAnswers) {
            setAnswers(JSON.parse(savedAnswers));
        }
    }, []);

    const handleMultipleAnswerChange = (qcmId, option, isChecked) => {
        setAnswers(prevAnswers => {
            const isMultipleChoice = qcms.find(qcm => qcm.id === qcmId)?.reponse.length > 1; // Vérifier si plusieurs réponses sont possibles

            if (isMultipleChoice) {
                // Cas QCM à choix multiple : Ajouter ou retirer l'option cochée
                const currentAnswers = prevAnswers[qcmId] || [];
                const updatedAnswers = isChecked
                    ? [...currentAnswers, option] // Ajouter l'option si cochée
                    : currentAnswers.filter(answer => answer !== option); // Supprimer l'option si décochée
                return {
                    ...prevAnswers,
                    [qcmId]: updatedAnswers, // Mettre à jour uniquement la question concernée
                };
            } else {
                // Cas QCM à choix unique : Remplacer l'ancienne réponse par la nouvelle
                return {
                    ...prevAnswers,
                    [qcmId]: isChecked ? [option] : [], // Stocke uniquement la dernière option sélectionnée
                };
            }
        });
    };

    const handleNextQcm = () => {
        if (currentQcmIndex < qcms.length - 1) {
            setCurrentQcmIndex(currentQcmIndex + 1);
            setExplanationVisible(false);
            setFeedbackVisible(false); // Réinitialiser la visibilité des feedbacks
            setIsAnswerCorrect(null); // Réinitialiser l'état de la réponse correcte
        }
    };

    const handlePreviousQcm = () => {
        if (currentQcmIndex > 0) {
            setCurrentQcmIndex(currentQcmIndex - 1);
            setExplanationVisible(false);
            setFeedbackVisible(false); // Réinitialiser la visibilité des feedbacks
            setIsAnswerCorrect(null); // Réinitialiser l'état de la réponse correcte
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("EtudeDeCas")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2 className='d-flex align-items-center'><FaChalkboardTeacher size={25} className='mr-2' />Etude de cas
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </div>

                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>
                                    Pour chaque QCM, une seule réponse est possible. Cochez la bonne réponse. Utilisez les boutons pour une meilleure gestion des QCM.
                                    <br />
                                    <b>Légende des icônes : </b>
                                    <FaEye className="ivt-align-menu" /> indique que la question a été déjà vue.
                                    <FaHeart className="ivt-align-menu" /> indique que la question est mise en favoris; dans ce cas cliquez sur le menu Simulateur &gt; Favoris.
                                    <br />
                                    Le bouton <FaTimesCircle className="ivt-align-menu" /> permet de terminer une simulation.
                                    Le bouton <FaArrowLeft className="ivt-align-menu" /> permet d'aller sur la question précédente.
                                    Le bouton <FaCheck className="ivt-align-menu" /> permet de vérifier si la réponse choisie est correcte.
                                    Le bouton <FaLightbulb className="ivt-align-menu" /> permet d'afficher le corrigé type d'une question.
                                    Le bouton <FaHeart className="ivt-align-menu" /> permet de mettre une question en favoris.
                                    Le bouton <FaArrowRight className="ivt-align-menu" /> permet d'aller sur la question suivante.
                                </small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Etude-de-cas`}> Etude de cas </Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        {etude.titre}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <tr className='d-flex justify-content-between align-items-center'>
                                            <div className='d-flex'>
                                                <td className='badge badge-secondary'> {qcms[currentQcmIndex]?.ref} </td>
                                                {/* <td>
                                                    {qcms[currentQcmIndex]?.deja_vu === "oui" && (
                                                        <i className="ml-1 fa fa-eye" title="Déjà vu"></i>
                                                    )}
                                                </td>
                                                <td>
                                                    {qcms[currentQcmIndex]?.favoris === "oui" && (
                                                        <i className="ml-1 fa fa-heart" title="Favoris"></i>
                                                    )}
                                                </td>
                                                {favorites.has(qcms[currentQcmIndex]?.id) && (
                                                    <i className="ml-1 fa fa-heart" title="Favoris"></i>
                                                )} */}
                                            </div>
                                            <td>
                                                {qcms.length > 0 ? `${currentQcmIndex + 1} sur ${qcms.length}` : "0 sur 0"}
                                            </td>
                                            <td className='d-flex'>
                                                <div className="mr-1 d-flex">
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${currentSize + 1}px`;
                                                            });
                                                        }}
                                                        title="Zoomer"
                                                    >
                                                        <i className="fa fa-search-plus"></i>
                                                    </Button>
                                                    <Button
                                                        className="btn btn-outline btn-secondary btn-sm ml-1"
                                                        onClick={() => {
                                                            const elements = document.querySelectorAll('.ibox-content, .ibox-content *');
                                                            elements.forEach(element => {
                                                                const currentSize = parseInt(window.getComputedStyle(element).fontSize);
                                                                element.style.fontSize = `${Math.max(12, currentSize - 1)}px`;
                                                            });
                                                        }}
                                                        title="Dézoomer"
                                                    >
                                                        <i className="fa fa-search-minus"></i>
                                                    </Button>
                                                </div>
                                                {isButtonLoading ? (
                                                    <button className="btn btn-success mr-2" disabled>
                                                        <i className="fa fa-spinner fa-spin mr-1"></i>
                                                        <span className="d-none d-sm-inline ml-2">
                                                            Chargement...
                                                        </span>
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-outline btn-warning" onClick={handleFinishEtude}>
                                                        <i className="fa fa-times-circle mr-1"></i>
                                                        Terminer l' étude de cas
                                                    </button>
                                                )}
                                            </td>
                                        </tr>
                                    </div>
                                    {!isLoading ? (
                                        <div className="ibox-content">
                                            {qcms.length > 0 ? (
                                                <form>
                                                    <input type="hidden" name="qcmidhidden" id="qcmidhidden" value={qcms[currentQcmIndex]?.id} />
                                                    <div id="question" style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex]?.question }}></div>
                                                    <div style={{ margin: '10px 10px' }}>
                                                        {Object.keys(qcms[currentQcmIndex])
                                                            .filter(key => key.startsWith('option') && qcms[currentQcmIndex][key] && (qcms[currentQcmIndex][key] !== 'non défini' && qcms[currentQcmIndex][key] !== 'vide')) // Filtrer les options non définies ou nulles
                                                            .map((key, index) => {
                                                                const optionLetter = String.fromCharCode(65 + index); // Convertir l'index en lettre (A, B, C, ...)
                                                                const isMultipleChoice = qcms[currentQcmIndex].reponse.length > 1; // Vérifie si plusieurs réponses
                                                                return (
                                                                    <div className="checkbox" key={key} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                                                        <label style={{ margin: 0, fontSize: '12px', cursor: 'pointer' }}>
                                                                            <input
                                                                                type={isMultipleChoice ? "checkbox" : "radio"} // Change input selon le type de réponse
                                                                                name={`qcmitem-${qcms[currentQcmIndex].id}`}
                                                                                value={optionLetter}
                                                                                className="i-checks choix"
                                                                                style={{ marginRight: '10px', cursor: 'pointer' }}
                                                                                onChange={(e) => handleMultipleAnswerChange(qcms[currentQcmIndex].id, optionLetter, e.target.checked)}
                                                                                checked={answers[qcms[currentQcmIndex].id]?.includes(optionLetter)}
                                                                            />
                                                                            {optionLetter} - <span id={`option${index + 1}`}>{qcms[currentQcmIndex][key]}</span>

                                                                            {feedbackVisible &&
                                                                                selectedAnswer?.qcmId === qcms[currentQcmIndex].id &&
                                                                                selectedAnswer.value.includes(optionLetter) &&
                                                                                !explanationVisible && (
                                                                                    qcms[currentQcmIndex].reponse.includes(optionLetter) ? (
                                                                                        <i
                                                                                            className="fa fa-thumbs-o-up fa-2x ivt-align-menu"
                                                                                            style={{ color: 'green', marginLeft: '5px' }}
                                                                                            title="Correct">
                                                                                        </i>
                                                                                    ) : (
                                                                                        <i
                                                                                            className="fa fa-thumbs-o-down fa-2x ivt-align-menu"
                                                                                            style={{ color: 'red', marginLeft: '5px' }}
                                                                                            title="Incorrect">
                                                                                        </i>
                                                                                    )
                                                                                )}

                                                                            {explanationVisible &&
                                                                                qcms[currentQcmIndex].reponse.includes(optionLetter) && (
                                                                                    <i
                                                                                        className="fa fa-thumbs-o-up fa-2x ivt-align-menu"
                                                                                        style={{ color: 'green', marginLeft: '5px' }}
                                                                                        title="Correct Answer">
                                                                                    </i>
                                                                                )}
                                                                        </label>
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                    {explanationVisible && (
                                                        <div className='d-flex' style={{ color: 'green' }}>
                                                            <div style={{ color: 'green' }}>
                                                                <span>Explication : </span>
                                                                <span dangerouslySetInnerHTML={{ __html: qcms[currentQcmIndex].explication }} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </form>
                                            ) : (
                                                <p>Aucun QCM trouvé pour cette etude.</p>
                                            )}
                                        </div>
                                    ) : (

                                        <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                            <span
                                                className="spinner-border spinner-border-lg text-success"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ width: '3rem', height: '3rem' }}
                                            ></span>
                                        </div>
                                    )}
                                    <div className="ibox-footer d-flex justify-content-end flex-wrap gap-2">

                                        <div className="ml-1">
                                            <Button
                                                onClick={handlePreviousQcm}
                                                style={{ display: currentQcmIndex === 0 ? 'none' : 'block' }}
                                                className="btn btn-outline btn-success"
                                            >
                                                <FaArrowCircleLeft className="me-1 mr-1" />
                                                <span className='labelInfo1'>Précédent</span>
                                            </Button>
                                        </div>
                                        <div className="ml-1">
                                            <Button
                                                onClick={handleNextQcm}
                                                style={{ display: currentQcmIndex === qcms.length - 1 ? 'none' : 'block' }}
                                                className="btn btn-outline btn-success"
                                            >
                                                <span className='labelInfo1'>Suivant</span>
                                                <FaArrowCircleRight className="me-1 ml-1" />
                                            </Button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Etude_demarrer;
